import { Extension, textInputRule } from "@tiptap/react";

/**
 * Lightweight emoji substitution for common ascii smileys while typing.
 *
 * Mirrors the input-rule approach from Tiptap's Savvy demo, with a reduced
 * rule set tailored for chat-style message composition.
 */
export const SmilieReplacer = Extension.create({
  name: "smilieReplacer",

  addInputRules() {
    return [
      textInputRule({ find: /:-\) $/, replace: "🙂 " }),
      textInputRule({ find: /:\) $/, replace: "🙂 " }),
      textInputRule({ find: /:-D $/, replace: "😃 " }),
      textInputRule({ find: /:D $/, replace: "😃 " }),
      textInputRule({ find: /;-\) $/, replace: "😉 " }),
      textInputRule({ find: /;\) $/, replace: "😉 " }),
      textInputRule({ find: /:-\( $/, replace: "😞 " }),
      textInputRule({ find: /:\( $/, replace: "😞 " }),
      textInputRule({ find: /:-P $/, replace: "😛 " }),
      textInputRule({ find: /:P $/, replace: "😛 " }),
      textInputRule({ find: /<3 $/, replace: "❤️ " }),
      textInputRule({ find: /<\/3 $/, replace: "💔 " }),
    ];
  },
});
